/** 會員列表視圖：由路由 meta.memberListProfile 決定，不依角色／權限推斷 UI */

export const MEMBER_LIST_PROFILE = {
    BUSINESS: 'business',
    GENERAL_ADMIN: 'generalAdmin',
    FULL: 'full'
};

/** 路由 name ↔ profile */
export const MEMBER_LIST_ROUTE_BY_PROFILE = {
    [MEMBER_LIST_PROFILE.BUSINESS]: 'MembersBusiness',
    [MEMBER_LIST_PROFILE.GENERAL_ADMIN]: 'MembersGeneralAdmin',
    [MEMBER_LIST_PROFILE.FULL]: 'MembersList'
};

/** 業務列表欄位／篩選（行政列表複製同一套呈現） */
const BUSINESS_LIST_COLUMNS = [
    'referral_department',
    'department',
    'name',
    'referral',
    'partner_assigned_at',
    'identity',
    'action'
];

const BUSINESS_LIST_FILTERS = [
    'name',
    'email',
    'phone',
    'id_number',
    'referral_department_id',
    'department_id',
    'rank_id',
    'referral_id',
    'mentor_id',
    'assigned_at_range',
    'referral_code',
    'deregistered'
];

export const PROFILE_CONFIG = {
    [MEMBER_LIST_PROFILE.BUSINESS]: {
        label: '會員管理',
        columns: BUSINESS_LIST_COLUMNS,
        filters: BUSINESS_LIST_FILTERS,
        actions: ['detail', 'password', 'orgChart'],
        /** 更改密碼：僅夥伴 */
        passwordIdentities: ['partner'],
        exportProfile: 'business',
        showColumnSettings: false,
        allowCreate: true,
        allowImport: true
    },
    [MEMBER_LIST_PROFILE.GENERAL_ADMIN]: {
        label: '用戶管理',
        // 列表呈現複製業務視角；不提供改密碼／組織圖（後端亦擋密碼）
        columns: BUSINESS_LIST_COLUMNS,
        filters: BUSINESS_LIST_FILTERS,
        actions: ['detail'],
        passwordIdentities: [],
        exportProfile: 'business',
        showColumnSettings: false,
        allowCreate: false,
        allowImport: false
    },
    [MEMBER_LIST_PROFILE.FULL]: {
        label: '會員管理（管理視角）',
        columns: null,
        filters: null,
        actions: ['detail', 'password'],
        /** null＝不限身份（可改全部） */
        passwordIdentities: null,
        exportProfile: 'full',
        showColumnSettings: true,
        allowCreate: true,
        allowImport: true
    }
};

export function getProfileFromRouteMeta(meta) {
    const profile = meta?.memberListProfile;
    if (profile && PROFILE_CONFIG[profile]) {
        return profile;
    }
    return MEMBER_LIST_PROFILE.FULL;
}

export function resolveMemberListBackRoute(fromRouteName) {
    const names = Object.values(MEMBER_LIST_ROUTE_BY_PROFILE);
    if (fromRouteName && names.includes(String(fromRouteName))) {
        return String(fromRouteName);
    }
    return MEMBER_LIST_ROUTE_BY_PROFILE[MEMBER_LIST_PROFILE.FULL];
}

/** 可否對該會員顯示「更改密碼」（依列表視圖規則） */
export function canChangePasswordForIdentity(listProfile, identity) {
    const cfg = PROFILE_CONFIG[listProfile] || PROFILE_CONFIG[MEMBER_LIST_PROFILE.FULL];
    const allowed = cfg.passwordIdentities;
    if (allowed === null) {
        return true;
    }
    if (!Array.isArray(allowed) || allowed.length === 0) {
        return false;
    }
    return allowed.includes(String(identity || ''));
}

/** 詳情分頁：full＝管理者；business／generalAdmin＝受限視角 */
export const MEMBER_DETAIL_PROFILE = {
    FULL: 'full',
    BUSINESS: 'business',
    GENERAL_ADMIN: 'generalAdmin'
};

export const MEMBER_DETAIL_TABS = {
    [MEMBER_DETAIL_PROFILE.FULL]: null,
    [MEMBER_DETAIL_PROFILE.BUSINESS]: [
        'detail',
        'activity_history',
        'points',
        'referral',
        'department',
        'rank',
        'task',
        'level'
    ],
    // 行政詳情：先維持與業務相同可見分頁集合（敏感欄位另控）
    [MEMBER_DETAIL_PROFILE.GENERAL_ADMIN]: [
        'detail',
        'activity_history',
        'points',
        'referral',
        'department',
        'rank',
        'task',
        'level'
    ]
};

/** 行政視角不可見身分證／生日；管理者／業務可見 */
export function canViewSensitivePersonalFields(detailProfile) {
    return detailProfile !== MEMBER_DETAIL_PROFILE.GENERAL_ADMIN;
}

export function getDetailProfileFromListRoute(fromRouteName) {
    const name = String(fromRouteName || '');
    if (name === MEMBER_LIST_ROUTE_BY_PROFILE[MEMBER_LIST_PROFILE.BUSINESS]) {
        return MEMBER_DETAIL_PROFILE.BUSINESS;
    }
    if (name === MEMBER_LIST_ROUTE_BY_PROFILE[MEMBER_LIST_PROFILE.GENERAL_ADMIN]) {
        return MEMBER_DETAIL_PROFILE.GENERAL_ADMIN;
    }
    return MEMBER_DETAIL_PROFILE.FULL;
}
